import { CSSProperties } from '@mui/material';

const textWithEllipsisStyle: CSSProperties = {
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
};

export default textWithEllipsisStyle;
